module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185653.43ca9ab2.jpg";